import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListFilters from '@/common/components/ListFilters'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import { useCompanies } from '@/common/hooks/queries/useCompanies'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { CompaniesTransformer } from '@/common/services/companiesTransformer'
import { Mapper } from '@/common/services/mapper'
import { Option } from '@/common/types/option'
import { failedTransactionsColumns } from '@/features/failedConsumptions/constants/failedConsumption.constant'
import { useClientConsumptions } from '@/features/failedConsumptions/hooks/useClientConsumptions'
import { FailedConsumptionsTransformer } from '@/features/failedConsumptions/services/failedConsumptionsTransformer'
import { ConsumptionData } from '@/features/failedConsumptions/types/consumption.type'
import { FailedConsumptionTableItem } from '@/features/failedConsumptions/types/failedConsumption.type'
import { ReceiptIcon } from 'lucide-react'

const FailedConsumptionsList = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [searchClient, setSearchClient] = useDebounce('')

  const { data: clientCompanies } = useCompanies({
    filters: { search: searchClient },
    mapper: Mapper.mapWithTransformer({ transformer: CompaniesTransformer.optionsTransformer() }),
  })

  const {
    data: clientConsumptions,
    meta,
    isFetching: isFetchingClientConsumptions,
    error: clientConsumptionsError = {} as any,
    refetch: refetchClientConsumptions,
  } = useClientConsumptions({
    filters: {
      status: 'failed',
      page: filterParams.page || 1,
      clientCompanyId: filterParams.client?.value,
    },
    mapper: Mapper.mapWithTransformer<ConsumptionData[], FailedConsumptionTableItem[]>({
      transformer: FailedConsumptionsTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <div className="flex">
        <ListHeader Icon={<ReceiptIcon className="w-10 h-10" strokeWidth={1.5} />} title="Transações falhas" />
      </div>

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={clientConsumptionsError?.status}
        refetchFunction={refetchClientConsumptions}
      >
        <div className="flex flex-col gap-6">
          <ListFilters
            filters={[
              {
                className: 'min-w-56',
                onChange: (client) => setFilterParams((prev) => ({ ...prev, client })),
                value: filterParams.client,
                onInputChange: (value) => setSearchClient(value),
                options: [{ label: 'Todas', value: '' }, ...((clientCompanies || []) as Option[])],
                placeholder: 'Empresa',
              },
            ]}
          />

          <Table
            className="max-h-[calc(100vh-184px)]"
            columns={failedTransactionsColumns}
            isLoadingData={isFetchingClientConsumptions}
            page={filterParams.page || 1}
            rows={clientConsumptions}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            rowEmptyValue="--"
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default FailedConsumptionsList
